(() => {
  const dialog = document.querySelector('[data-gtfo-gift-reminder]');
  if (!dialog) return;
  const size = dialog.querySelector('[data-reminder-size]');
  const add = dialog.querySelector('[data-reminder-add]');
  const skip = dialog.querySelector('[data-reminder-skip]');
  const status = dialog.querySelector('[data-reminder-status]');
  const checkoutLabel = add.textContent;
  const strings = JSON.parse(dialog.querySelector('[data-reminder-strings]').textContent);
  const variants = JSON.parse(dialog.querySelector('[data-reminder-variants]').textContent);
  const shirtId = 9174092251349;
  let cart = JSON.parse(dialog.querySelector('[data-reminder-cart]').textContent), skipped = '', resolveChoice, adding = false;
  const isGift = item => item.product_id === shirtId && (item.properties?._mr === '1' || item.properties?._gtfo_free_shirt === 'outsiders');
  const signature = value => value.items.filter(item => !isGift(item)).map(item => `${item.key}:${item.quantity}:${item.original_line_price}`).join('|');
  const qualifies = value => value.currency === 'USD' && value.items.reduce((sum, item) => sum + (isGift(item) || item.gift_card ? 0 : item.original_line_price), 0) >= 19901;
  const needsReminder = value => qualifies(value) && !value.items.some(item => isGift(item) && item.final_line_price === 0) && skipped !== signature(value);
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  async function readCart() {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw new Error();
    return response.json();
  }
  const selectedGift = (value, selectedVariant) => value.items.find(item => isGift(item) && item.final_line_price === 0 && item.variant_id === Number(selectedVariant) && item.quantity === 1);
  function express() {
    if (!cart) return;
    if (dialog.open && size.disabled && !adding) populateSizes();
    document.querySelectorAll('#CartPageForm .additional-checkout-buttons, #CartDrawerForm .additional-checkout-buttons').forEach(group => {
      let gate = group.previousElementSibling;
      if (!gate?.matches('[data-gift-express-gate]')) {
        gate = document.createElement('div');
        gate.dataset.giftExpressGate = '';
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'btn gtfo-gift-express-button'; button.textContent = strings.express;
        const note = document.createElement('p'); note.textContent = strings.expressNote;
        gate.append(button, note); group.before(gate);
        button.addEventListener('click', async () => {
          if (adding) return;
          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store'});
            if (!response.ok) throw new Error();
            cart = await response.json();
            await confirm(cart, true);
          } catch (_) { status.textContent = strings.error; }
          express();
        });
      }
      const blocked = needsReminder(cart);
      gate.hidden = !blocked;
      group.hidden = blocked;
    });
  }
  function finish(result) {
    dialog.close();
    if (resolveChoice) { const done = resolveChoice; resolveChoice = null; done(result); }
    express();
  }
  function populateSizes() {
    const available = variants.filter(variant => variant.available);
    if (!available.length) return false;
    size.replaceChildren(new Option(strings.choose, ''));
    available.forEach(variant => size.add(new Option(variant.title, String(variant.id))));
    status.textContent = '';
    add.disabled = false;
    size.disabled = false;
    return true;
  }
  async function confirm(value, expressMode = false) {
    cart = value;
    if (!needsReminder(cart)) return true;
    if (dialog.open) return false;
    add.textContent = expressMode ? strings.expressAdd : checkoutLabel;
    size.replaceChildren(new Option(strings.choose, ''));
    add.disabled = true;
    size.disabled = true;
    status.textContent = strings.unavailable;
    populateSizes();
    dialog.showModal();
    size.focus();
    return new Promise(resolve => { resolveChoice = resolve; });
  }
  skip.addEventListener('click', () => { if (!adding) { skipped = signature(cart); finish(true); } });
  dialog.addEventListener('cancel', event => { event.preventDefault(); if (!adding) finish(false); });
  dialog.querySelector('[data-reminder-close]').addEventListener('click', () => { if (!adding) finish(false); });
  add.addEventListener('click', async () => {
    if (!size.value) { status.textContent = strings.choose; size.focus(); return; }
    const selectedSize = size.value;
    adding = true; add.disabled = true; skip.disabled = true; size.disabled = true; status.textContent = strings.adding;
    try {
      cart = await readCart();
      if (!qualifies(cart)) {
        status.textContent = strings.ineligible;
        document.dispatchEvent(new CustomEvent('cart:build'));
        return;
      }
      if (selectedGift(cart, selectedSize)) { finish(true); return; }
      for (const item of cart.items.filter(isGift)) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});
        if (!response.ok) throw new Error();
        cart = await response.json();
      }
      if (!variants.some(variant => String(variant.id) === selectedSize && variant.available)) {
        status.textContent = strings.sizeUnavailable;
        return;
      }
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(selectedSize),quantity:1,properties:{_mr:'1'}}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || strings.error);
      for (let attempt = 0; attempt < 20; attempt++) {
        await pause(500);
        const updated = await readCart();
        const gift = selectedGift(updated, selectedSize);
        if (gift) { cart = updated; finish(true); return; }
      }
      throw new Error();
    } catch (error) { status.textContent = error.message || strings.error; }
    finally {
      adding = false; add.disabled = false; skip.disabled = false; size.disabled = false;
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  });
  document.addEventListener('gtfo:gift-cart', event => { cart = event.detail; express(); });
  let refreshTimer;
  const observer = new MutationObserver(() => { clearTimeout(refreshTimer); refreshTimer = setTimeout(express, 100); });
  document.querySelectorAll('#CartPageForm,#CartDrawerForm').forEach(form => observer.observe(form, {childList:true,subtree:true}));
  window.gtfoGiftReminder = {confirm, get isAdding() { return adding; }};
  express();
})();
